import {Component, Input, OnInit} from '@angular/core';
import {AttributeEntity} from '@app/core/model/integration-models';

@Component({
    selector: 'ngc-piishield-attributes-list',
    templateUrl: './piishield-attributes-list.component.html',
    styleUrls: ['./piishield-attributes-list.component.scss']
})
export class PIIShieldAttributesListComponent implements OnInit {

    @Input() isDialog = true;
    @Input() headerText: string;
    @Input() showErrorIcon: boolean;
    @Input() attributesList: AttributeEntity[];
    @Input() attributeStyleClass: string;

    constructor() { }

    ngOnInit(): void {
    }

}
